import { createRouter, createWebHistory } from 'vue-router'
import MobileOnlyNoScroll from '../components/MobileOnlyNoScroll'
import MovieListView from '../views/movie/ListView'
import MovieListByActorView from '../views/movie/ListByActorView'
import MovieListByGenreView from '../views/movie/ListByGenreView'
import MovieDetailView from '../views/movie/DetailView'

const routes = [
  {
    path: '/',
    name: 'landing',
    redirect: to => {
      return { name: 'movie-list' }
    }
  },
  {
    path: '/app',
    name: 'base',
    component: MobileOnlyNoScroll,
    children: [
      {
        path: 'movie',
        name: 'movie-list',
        component: MovieListView
      },
      {
        path: 'movie-by-actor',
        name: 'movie-by-actor',
        component: MovieListByActorView
      },
      {
        path: 'movie-by-genre',
        name: 'movie-by-genre',
        component: MovieListByGenreView
      },
      {
        path: 'movie-detail',
        name: 'movie-detail',
        component: MovieDetailView
      }
    ]
  }
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
